// services/payment.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { environment } from '../../../environments/environment';

export interface PaymentMethodDto {
  id: string;
  brand: string;
  lastFourDigits: string;
  expiryMonth: number;
  expiryYear: number;
  isDefault: boolean;
}

interface SetupIntentResponse {
  clientSecret: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private apiUrl = environment.apiUrl + 'Payments/';
  private stripePromise: Promise<Stripe | null> | null = null;

  constructor(private http: HttpClient) {}

  // Card data is entered directly into a Stripe Element and confirmed client-side —
  // it never passes through our API, only Stripe's servers see it.
  getStripe(): Promise<Stripe | null> {
    if (!this.stripePromise) {
      this.stripePromise = loadStripe(environment.stripePublishableKey);
    }
    return this.stripePromise;
  }

  createSetupIntent(userId: number): Observable<SetupIntentResponse> {
    return this.http.post<SetupIntentResponse>(`${this.apiUrl}setup-intent/${userId}`, {});
  }

  getPaymentMethods(userId: number): Observable<PaymentMethodDto[]> {
    return this.http.get<PaymentMethodDto[]>(`${this.apiUrl}methods/${userId}`);
  }

  setDefaultPaymentMethod(userId: number, paymentMethodId: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}methods/${userId}/default/${paymentMethodId}`, {});
  }

  deletePaymentMethod(paymentMethodId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}methods/${paymentMethodId}`);
  }
}
